import { STATE_NAMES } from "encamp-shared/src/constants/states";
import { SUBMISSION_STATUS_EMOJI_LABEL } from "encamp-shared/src/submissions";
import { SubmissionStatus } from "generated-graphql/graphql";

// Status filter options for multi-select checkbox menu
export const STATUS_FILTER_OPTIONS = SUBMISSION_STATUS_EMOJI_LABEL as Record<
  SubmissionStatus,
  string
>;

// All statuses derived from the filter options object keys
export const ALL_STATUSES = Object.keys(STATUS_FILTER_OPTIONS) as SubmissionStatus[];

// US States list for filtering
export const US_STATES = Object.keys(STATE_NAMES);

// Due-date grid columns are sized for the warning that renders under the date,
// not for the date alone.
export const DUE_DATE_COLUMN_SIZING = { flex: 1.6, minWidth: 200 } as const;
